import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { useRouter } from 'next/router';
import { TrackClick } from '@g4/trackster';
import { hook } from '@g4/automation-hooks';
import Link from '@g4/next-furniture/Link';
import { useAuthentication } from '@g4/next-furniture/Authentication/AuthenticationProvider';
import ExitPopup from '@g4/next-furniture/UpdatePassword/ExitPopup';

import { useModal } from '../../ModalProvider';
import { useMedia } from '../../Boneyard';

import BLUE_LOGO from '../../../images/logo-allegiant-blue.svg';
import WHITE_LOGO from '../../../images/logo-allegiant-white.svg';

import IsStadium from '../../../utils/isStadium';

const propTypes = {
  logoHeight: PropTypes.number,
  automationHook: PropTypes.string,
};

const defaultProps = {
  logoHeight: 70,
};

const StyledLogo = styled.img`
  display: block;
  height: ${props => props.logoHeight}px;
  padding: ${props => props.theme.spacing(2)} 0;
  margin-right: ${props => props.theme.spacing(20)};

  transition: height 0.2s ease-in-out;
`;

StyledLogo.propTypes = {
  logoHeight: PropTypes.number,
};

StyledLogo.defaultProps = {
  logoHeight: 70,
};

const Logo = ({ logoHeight, automationHook }) => {
  const mq = useMedia();
  const router = useRouter();
  const { authData, logout, setAuthData } = useAuthentication();
  const { setShowModal, setTitle, setContent, unSetModal } = useModal();

  const showExitPopup = destination => {
    setContent(
      <ExitPopup
        isMobile={mq.lte('sm')}
        closePopup={unSetModal}
        routeTo={destination}
        logout={logout}
        setAuthData={setAuthData}
      />
    );
    setTitle('');
    setShowModal(true);
  };

  const handleClick = event => {
    const destination = '/';
    if (
      authData?.forceResetPasswordFlag &&
      window.location.pathname.includes('/updatepassword')
    ) {
      event.preventDefault();
      showExitPopup(destination);
    } else {
      router.push(destination);
    }
  };

  return (
    <Link href="/">
      {({ anchorProps }) => (
        <TrackClick
          action="Logo"
          category="site_click_tracking"
          label="Allegiant Air - Cheap Flights, Air + Hotel Packages, Discounted Car Rentals"
        >
          <a
            href="/"
            aria-label="Go to home page"
            {...anchorProps}
            {...hook(automationHook)}
            onClick={handleClick}
          >
            <StyledLogo
              alt="Allegiant logo"
              logoHeight={logoHeight}
              src={IsStadium() ? WHITE_LOGO : BLUE_LOGO}
            />
          </a>
        </TrackClick>
      )}
    </Link>
  );
};

Logo.propTypes = propTypes;

Logo.defaultProps = defaultProps;

export default withTheme(Logo);
